import { CarOutlined, DollarOutlined } from '@ant-design/icons';
import { NavBar, TabBar } from 'antd-mobile';
import {
    UserOutline
} from 'antd-mobile-icons';
import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useMe } from '../../zustand/store';
import Header from './header';

const titleObj = {
    "/car": "Car",
    "/finance": "Finance",
    "/me": "Account"
}


const Bottom = () => {
    // const history = useHistory()
    const navigate = useNavigate();
    const location = useLocation()
    const { pathname } = location

    const setRouteActive = (value) => {
        navigate(value)
    }

    const tabs = [
        {
            key: '/car',
            // title: 'Car',
            icon: <CarOutlined />,
        },
        {
            key: '/finance',
            // title: 'Finance',
            icon: <DollarOutlined />,
        },
        {
            key: '/me',
            // title: 'Account',
            icon: <UserOutline />,
        },
        // {
        //     key: '',
        //     // title: 'Account',
        //     icon: <></>,
        // },
    ]

    return (
        <TabBar style={{ backgroundColor: "white" }} activeKey={pathname} onChange={value => setRouteActive(value)}>
            {tabs.map(item => (
                <TabBar.Item key={item.key} icon={item.icon} title={titleObj[item.key]} />
            ))}
        </TabBar>
    )
}

function MainPage() {
    const me = useMe();
    const navigate = useNavigate();
    const location = useLocation()
    const { pathname } = location
    useEffect(() => {
        const token = localStorage.getItem("cars_token");
        if (token) {
            me.execute();
        } else {
            navigate("/auth")
        }
    }, [])

    return (
        <div style={{
            // height: "100vh",
            display: "flex",
            flexDirection: "column",
        }}>
            <div
                style={{
                    // flex: 0,
                    // borderBottom: "solid 1px var(--adm-color-border)",
                    height: "49px",
                    // backgroundColor: "red"
                }}
            >
                <Header title={titleObj[pathname]} />
            </div>
            <div
                style={{
                    // backgroundColor: "green",
                    // flex: 1,
                    // display: "flex",
                    // justifyContent: "center",
                    // alignItems: "center",
                    width: "100%",
                    height: "calc(100vh - 109px)",
                    border: "1px solid black",
                    borderRight: 0,
                    borderLeft: 0,
                    overflow: "auto"
                    // padding: "10px"
                }}
            >
                <Outlet />
            </div>
            <div style={{
                // flex: 0,
                // borderTop: "solid 1px var(--adm-color-border)"
                // borderTop: "1px solid black",
                height: "50px",
                backgroundColor: "white",
                paddingBottom: "10px"
            }}>
                <Bottom />
            </div>
        </div>
    )
}

export default MainPage